import ReactGA from "react-ga4";

export const initGA = () => {
  const measurementId = process.env.REACT_APP_GA_MEASUREMENT_ID;
  if (measurementId) {
    ReactGA.initialize(measurementId);
  }
};

export const trackPageView = (path: string) => {
  ReactGA.send({ hitType: "pageview", page: path });
};

// Uses GA4 event name format: standard names (login, sign_up, purchase, select_content)
// where they fit, descriptive snake_case for custom events.
export const trackEvent = (
  eventName: string,
  params?: Record<string, unknown>,
) => {
  ReactGA.event(eventName, params);
};

interface UserContext {
  id: string;
  roles: string[];
  subscriptionPlan?: string;
  subscriptionStatus?: string;
}

// Sets GA4 user ID and user properties — call once after authentication.
// This enriches all subsequent events with user-level context.
export const setUserContext = ({
  id,
  roles,
  subscriptionPlan,
  subscriptionStatus,
}: UserContext) => {
  ReactGA.set({ userId: id });
  ReactGA.gtag("set", "user_properties", {
    user_role: roles[0] ?? "unknown",
    subscription_plan: subscriptionPlan ?? "unknown",
    subscription_status: subscriptionStatus ?? "unknown",
  });
};
